import X2JS from 'x2js';

export class Tools {
  private static _x2jsInstance: X2JS;
  private static readonly _accents: string = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
  private static readonly _accentsOut: string = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';

  static get x2js(): X2JS {
    if (!Tools._x2jsInstance) {
      Tools._x2jsInstance = new X2JS();
    }
    return Tools._x2jsInstance;
  }

  static generateFormatedTimestamp(): string {
    const cDate = new Date();
    let cTimestamp = cDate.toISOString();
    cTimestamp = cTimestamp.replace(/-/g, '');
    cTimestamp = cTimestamp.replace(/:/g, '');
    cTimestamp = [cTimestamp.slice(0, 15), 'Z'].join('');
    return cTimestamp;
  }

  static removeAccents(str: string): string {
    let _r = str.split('');
    const strLen = _r.length;
    let i, x;
    for (i = 0; i < strLen; i++) {
      if ((x = Tools._accents.indexOf(str[i])) != -1) {
        _r[i] = Tools._accentsOut[x];
      }
    }
    return _r.join('');
  }

  static replaceLast(str: string, pattern: string | RegExp, replacement = ''): string {
    const match = typeof pattern === 'string' ? pattern : (RegExp(pattern.source, 'g').exec(str) || []).slice(-1)[0];
    if (!match) return str;
    const last = str.lastIndexOf(match);
    return last !== -1 ? `${str.slice(0, last)}${replacement}${str.slice(last + match.length)}` : str;
  }

  static copyInClipboard(value: string) {
    navigator.clipboard.writeText(value).then(() => {});
  }

  static replaceSpaceWithPlusSign(value: string) : string {
    if (value.length <= 0)
      return value;

    return value.toString().replace(" ", "+").toString();
  }
}
